export const BarChartIllustration = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="659"
      height="361"
      fill="none"
      viewBox="0 0 659 361"
      className="compare-bar-blobs"
    >
      <g filter="url(#filter0_d_6026_23652)">
        <rect
          width="633"
          height="336"
          x="13"
          y="10"
          fill="#FAFAFA"
          rx="10.25"
          shapeRendering="crispEdges"
        ></rect>
        <rect
          width="628"
          height="331"
          x="15.5"
          y="12.5"
          stroke="url(#paint0_linear_6026_23652)"
          strokeWidth="5"
          rx="7.75"
          shapeRendering="crispEdges"
        ></rect>
        <path
          stroke="#BBADAD"
          strokeDasharray="2.05 2.05"
          strokeWidth="1.025"
          d="M621 142.512H49M621 219.364H49M621 296.216H49"
        ></path>
        <path
          fill="url(#paint1_linear_6026_23652)"
          d="M265 112h139v185H265z"
        ></path>
        <path
          fill="url(#paint2_linear_6026_23652)"
          d="M71 210h140v87H71z"
        ></path>
        <path
          fill="url(#paint3_linear_6026_23652)"
          d="M458 179h139v118H458z"
        ></path>
        <g clipPath="url(#clip0_6026_23652)">
          <g filter="url(#filter1_f_6026_23652)">
            <circle
              cx="15.574"
              cy="15.574"
              r="15.574"
              fill="url(#paint4_linear_6026_23652)"
              transform="matrix(.99999 -.0049 -.00492 -.99999 125.255 197.402)"
            ></circle>
          </g>
          <g
            stroke="#000"
            strokeLinecap="round"
            strokeMiterlimit="1.333"
            strokeWidth="1.501"
            clipPath="url(#clip1_6026_23652)"
          >
            <path d="M134.449 182.743c0 .429.781 1.502 2.252 1.502 1.532 0 2.252-.965 2.252-1.43"></path>
            <path
              strokeLinejoin="round"
              d="m145.709 179.741-3.003 1.501 3.003 1.502M127.694 179.741l3.002 1.501-3.002 1.502"
            ></path>
          </g>
        </g>
        <g clipPath="url(#clip2_6026_23652)">
          <g filter="url(#filter2_f_6026_23652)">
            <circle
              cx="16.593"
              cy="16.593"
              r="16.593"
              fill="url(#paint5_linear_6026_23652)"
              transform="matrix(.99999 -.0049 -.00492 -.99999 511.793 165.972)"
            ></circle>
          </g>
          <g
            stroke="#000"
            strokeLinecap="round"
            strokeMiterlimit="1.333"
            strokeWidth="1.599"
            clipPath="url(#clip3_6026_23652)"
          >
            <path d="M525.51 148.004c0 .457.832 1.599 2.399 1.599 1.632 0 2.399-1.028 2.399-1.523"></path>
            <path
              strokeLinejoin="round"
              d="m537.504 144.805-3.199 1.599 3.199 1.6M518.313 144.805l3.199 1.599-3.199 1.6"
            ></path>
          </g>
        </g>
        <g clipPath="url(#clip4_6026_23652)">
          <g filter="url(#filter3_f_6026_23652)">
            <circle
              cx="15.199"
              cy="15.199"
              r="15.199"
              fill="url(#paint6_linear_6026_23652)"
              transform="matrix(.99999 -.0049 -.00492 -.99999 316.548 97.453)"
            ></circle>
          </g>
          <g
            stroke="#000"
            strokeLinecap="round"
            strokeMiterlimit="1.333"
            strokeWidth="1.465"
            clipPath="url(#clip5_6026_23652)"
          >
            <path d="M335.224 85.663c0 .419.762 1.465 2.197 1.465 1.495 0 2.198-.942 2.198-1.395"></path>
            <path
              strokeLinejoin="round"
              d="m346.213 82.733-2.93 1.465 2.93 1.465M328.631 82.733l2.931 1.465-2.931 1.465"
            ></path>
          </g>
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_6026_23652"
          x1="329.5"
          x2="329.5"
          y1="10"
          y2="346"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7E1EE"></stop>
          <stop offset="1" stopColor="#EADBF5"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_6026_23652"
          x1="334.5"
          x2="334.5"
          y1="112"
          y2="297"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7E1EE"></stop>
          <stop offset="1" stopColor="#EADBF5"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_6026_23652"
          x1="141"
          x2="141"
          y1="210"
          y2="297"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EDF6CC"></stop>
          <stop offset="1" stopColor="#D2DEA5"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_6026_23652"
          x1="527.5"
          x2="527.5"
          y1="179"
          y2="297"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EBF0FC"></stop>
          <stop offset="1" stopColor="#AFC9FF"></stop>
        </linearGradient>
        <linearGradient
          id="paint4_linear_6026_23652"
          x1="3.973"
          x2="25.864"
          y1="5.451"
          y2="22.974"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C1DB60"></stop>
          <stop offset="1" stopColor="#EECF7F"></stop>
        </linearGradient>
        <linearGradient
          id="paint5_linear_6026_23652"
          x1="-9.861"
          x2="16.593"
          y1="-8.702"
          y2="33.186"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4474DE"></stop>
          <stop offset="1" stopColor="#CED9F1"></stop>
        </linearGradient>
        <linearGradient
          id="paint6_linear_6026_23652"
          x1="3.8"
          x2="33.411"
          y1="0"
          y2="11.521"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCA2F3"></stop>
          <stop offset="0.573" stopColor="#FF7AA2"></stop>
          <stop offset="1" stopColor="#F3D4A2"></stop>
        </linearGradient>
        <clipPath id="clip0_6026_23652">
          <path fill="#fff" d="M164.136 158H117v47.136h47.136z"></path>
        </clipPath>
        <clipPath id="clip1_6026_23652">
          <path fill="#fff" d="M146.46 178.99h-19.517v6.005h19.517z"></path>
        </clipPath>
        <clipPath id="clip2_6026_23652">
          <path fill="#fff" d="M553.21 124H503v50.21h50.21z"></path>
        </clipPath>
        <clipPath id="clip3_6026_23652">
          <path fill="#fff" d="M538.304 144.006h-20.79v6.397h20.79z"></path>
        </clipPath>
        <clipPath id="clip4_6026_23652">
          <path fill="#fff" d="M354.492 59h-46v46h46z"></path>
        </clipPath>
        <clipPath id="clip5_6026_23652">
          <path fill="#fff" d="M346.945 82h-19.047v5.861h19.047z"></path>
        </clipPath>
        <filter
          id="filter0_d_6026_23652"
          width="657.615"
          height="360.615"
          x="0.692"
          y="0.154"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="2.462"></feOffset>
          <feGaussianBlur stdDeviation="6.154"></feGaussianBlur>
          <feComposite in2="hardAlpha" operator="out"></feComposite>
          <feColorMatrix values="0 0 0 0 0.0873 0 0 0 0 0.0658333 0 0 0 0 0.334167 0 0 0 0.08 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6026_23652"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_6026_23652"
            result="shape"
          ></feBlend>
        </filter>
        <filter
          id="filter1_f_6026_23652"
          width="54.961"
          height="54.96"
          x="113.272"
          y="154.272"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feBlend
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          ></feBlend>
          <feGaussianBlur
            result="effect1_foregroundBlur_6026_23652"
            stdDeviation="5.953"
          ></feGaussianBlur>
        </filter>
        <filter
          id="filter2_f_6026_23652"
          width="56.727"
          height="56.726"
          x="499.941"
          y="120.935"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feBlend
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          ></feBlend>
          <feGaussianBlur
            result="effect1_foregroundBlur_6026_23652"
            stdDeviation="5.885"
          ></feGaussianBlur>
        </filter>
        <filter
          id="filter3_f_6026_23652"
          width="50.292"
          height="50.292"
          x="306.526"
          y="57.034"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feBlend
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          ></feBlend>
          <feGaussianBlur
            result="effect1_foregroundBlur_6026_23652"
            stdDeviation="4.973"
          ></feGaussianBlur>
        </filter>
      </defs>
    </svg>
  )
}
